import React from 'react';
import { styled } from '@mui/material/styles';
import { Link, LinkProps } from '@mui/material';

const StyledLink = styled(Link)(({ theme }) => ({
    textTransform: 'none',
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: '16px',
    padding: theme.spacing(1, 0),
    display: 'block',
    cursor: 'pointer'
}));

export const PayLinkButton: React.FC<React.PropsWithChildren<LinkProps>> = props => (
    <StyledLink color="primary" {...props} className={props.className} />
);
